import { Component } from '@angular/core';
import { Cart } from '@spartacus/cart/base/root/models';
import { SavedCartDetailsService } from '@spartacus/cart/saved-cart/components';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'saved-cart-items',
  templateUrl: './saved-cart-items.component.html',
  styleUrl: './saved-cart-items.component.scss',
  standalone: false,
})
export class SavedCartItemsComponent {
  savedCart$: Observable<Cart | undefined> = this.savedCartDetailsService.getCartDetails().pipe(
    tap(cart => {
      if ((cart?.entries ?? []).length <= 0 && !!cart?.code) {
        this.savedCartService.deleteSavedCart(cart.code);
      }
    }),
  );

  constructor(
    protected savedCartDetailsService: SavedCartDetailsService,
    protected savedCartService: SavedCartFacade,
  ) {}
}
